var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('log-tab',{ref:"tabLogTable",attrs:{"entity-id":_vm.entityId,"entity-type":"reservation-special-day"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }